const uk = {
  100000001:'Ключова інформація',
  100000002:'Назва токена',
  100000003:'Створювач копії',
  100000004:'Час створення екземпляра',
  100000005:'Основна інформація',
  100000006:'Відповідний блокчейн/протокол  ',
  100000007:'Адреса смарт-контракту  ',
  100000008:'Дата випуску',
  100000009:'Всього постачання',
  100000010:'Циркуляційне Постачання',
  100000011:'Ринкова вартість',
  100000012:'інфо',
  100000013:'Інформація в соціальних мережах',
  100000014:'Веб-сайт',
  100000015:'White Paper',
  100000016:'Браузер блокчейну  ',
  100000017:'Оцінка проекту',
  100000018:'Рейтинг',
  100000019:'Топ',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Час оновлення',
  100000027:'Оцінка безпеки  ',
  100000028:'Оцінка безпеки контракту  ',
  100000029:'Статистика ризикових проєктів  ',
  100000030:'Деталі коду контракту  ',
  100000031:'Податок на покупку  ',
  100000032:'Податок на продаж  ',
  100000033:'Це міскод  ',
  100000034:'Можна знову mint  ',
  100000035:'Існує чорний список  ',
  100000036:'Існує білий список  ',
  100000037:'Є анти-кит  ',
  100000038:'Можна змінити податкову ставку  ',
  100000039:'Є відкритим кодом  ',
  100000040:'Є приховані власники  ',
  100000041:'Можна знищити себе  ',
  100000042:'Є проксі-контрактом  ',
  100000043:'Можна змінити баланс  ',
  100000044:'Можна виконувати зовнішні виклики  ',
  100000045:'Можна відновити право власності  ',
  100000046:'Є період спокою для транзакцій  ',
  100000047:'Можна призупинити перекази  ',
  100000048:'Право власності не відмовлено  ',
  100000049:'Є регульованим анти-китом  ',
  100000050:'Занадто багато десяткових знаків  ',
  100000051:'Публічні методи Mint і Burn  ',
  100000052:'Спалення токенів оновлює загальну кількість  ',
  100000053:'Спалення токенів оновлює баланс  ',
  100000054:'Переказ самому собі збільшує баланс  ',
  100000055:'Транзакція на суму',
  100000056:'Баланс не оновлено під час переказу  ',
  100000057:'Баланс одержувача буде витрачено  ',
  100000058:'Виклик TransferFrom при перевищенні балансу призводить до помилки  ',
  100000059:'Метод BurnFrom оновлює загальну кількість  ',
  100000060:'Визначте податок на купівлю токена. Понад 5% вважається високою податковою ставкою',
  100000061:'Визначте податок на продаж токена. Понад 5% вважається високою податковою ставкою',
  100000062:'Перевірте, чи є токен шахрайською схемою типу honeypot',
  100000063:'Перевірте, чи можна створити більше токенів',
  100000064:'Перевірте, чи має токен чорний список, який може обмежувати користувачів у обміні або передачі токенів',
  100000065:'Перевірте, чи має токен білий список, що дозволяє адресам обходити будь-які обмеження',
  100000066:'Перевірте, чи має токен механізми проти великих власників (анти-кит)',
  100000067:'Перевірте, чи є у токена податок і чи може цей податок бути змінений привілейованими ролями',
  100000068:'Перевірте, чи був токен перевірений у блокчейн-експлорері',
  100000069:'Перевірте, чи є у токена прихований власник, який може маніпулювати контрактом, навіть якщо здається, що права власності були відхилені',
  100000070:'Перевірте, чи може токен самознищитися',
  100000071:'Перевірте, чи є токен проксі-контрактом, який делегує виклики функцій контракту реалізації',
  100000072:'Перевірте, чи може баланс токена бути змінений привілейованими ролями',
  100000073:'Перевірте, чи викликає токен зовнішні контракти',
  100000074:'Перевірте, чи має токен лазівку для відновлення прав власності',
  100000075:'Перевірте, чи має токен механізм затримки при передачі',
  100000076:'Перевірте, чи може торгівля токеном бути призупинена привілейованими ролями',
  100000077:'Перевірте, чи були права власника відхилені',
  100000078:'Перевірте, чи можуть механізми проти великих власників бути змінені привілейованими ролями',
  100000079:'Перевірте, чи є значення, що повертається функцією decimals(), більше або дорівнює 5',
  100000080:'Перевірте, чи призведе виклик функцій mint() та burn() випадковими користувачами до відхилення',
  100000081:'Перевірте, чи правильно оновлюється totalSupply при виклику функції burn()',
  100000082:"Перевірте, чи правильно оновлюється дозволене значення при виклику функції burnFrom()",
  100000083:'Перевірте, чи збільшиться баланс відправника при виклику функції transfer(), якщо отримувач такий самий, як і відправник транзакції',
  100000084:'Перевірте, чи зазнає невдачі виклик функції transfer() з кількістю, що перевищує баланс',
  100000085:"Перевірте, чи оновлюється відповідно дозволене значення для витрачаючого після виклику функції transferFrom()",
  100000086:"Перевірте, чи використовує виклик функції transferFrom() баланс витрачаючого",
  100000087:"Перевірте, чи правильно оновлюється дозволена сума після виклику transferFrom(), або чи відміняється транзакція, якщо сума недійсна.",
  100000088:"Перевірте, чи правильно оновлюється totalSupply при виклику функції burnFrom()",
  100000089:'Перевірте, чи існує право на створення токенів',
  100000090:'Перевірте, чи існує право на заморожування',
  100000091:'Перевірте, чи можна змінити метадані',
  100000092:'Критичний',
  100000093:'Важливий',
  100000094:'Середній',
  100000095:'Незначний',
  100000096:'Інформаційний',
  100000097:'Відмовлено від дозволу на mint  ',
  100000098:'Відмовлено від дозволу на замороження  ',
  100000099:'Можна змінити метадані токена  ',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default uk


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/uk.js